module.exports = __webpack_public_path__ + "img/xiaomi12timage4.59d04464.png";